import { render, staticRenderFns } from "./teamTemplate.vue?vue&type=template&id=3fe2fae6&scoped=true"
import script from "./teamTemplate.vue?vue&type=script&lang=js"
export * from "./teamTemplate.vue?vue&type=script&lang=js"
import style0 from "./teamTemplate.vue?vue&type=style&index=0&id=3fe2fae6&prod&lang=css"
import style1 from "./teamTemplate.vue?vue&type=style&index=1&id=3fe2fae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe2fae6",
  null
  
)

export default component.exports